type VerifyAccessCacheKey = string;

interface VerifyAccessCacheEntry {
  userId: string;
  feature: string;
  access: boolean;
  expiresAt: number;
}

const DEFAULT_TTL_MS = 30_000;

const cache = new Map<VerifyAccessCacheKey, VerifyAccessCacheEntry>();

function makeKey(userId: string, feature: string): VerifyAccessCacheKey {
  return `${userId}::${feature || 'none'}`;
}

export function getVerifyAccessCached(userId: string, feature: string): VerifyAccessCacheEntry | null {
  const key = makeKey(userId, feature);
  const entry = cache.get(key);
  if (!entry) return null;
  const now = Date.now();
  if (entry.expiresAt <= now) {
    cache.delete(key);
    return null;
  }
  return entry;
}

export function setVerifyAccessCached(userId: string, feature: string, access: boolean, ttlMs: number = DEFAULT_TTL_MS): void {
  const key = makeKey(userId, feature);
  cache.set(key, {
    userId,
    feature,
    access,
    expiresAt: Date.now() + Math.max(1_000, ttlMs)
  });
}

export function invalidateVerifyAccessForUser(userId: string): void {
  for (const [key, entry] of cache.entries()) {
    if (entry.userId === userId) {
      cache.delete(key);
    }
  }
}

export function clearExpiredVerifyAccess(): void {
  const now = Date.now();
  for (const [key, entry] of cache.entries()) {
    if (entry.expiresAt <= now) {
      cache.delete(key);
    }
  }
}


